import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScrollZoom = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M32.8572 14.8571C32.8572 7.75634 27.1008 2 20 2C12.8992 2 7.14288 7.75634 7.14288 14.8571V25.1429C7.14288 32.2437 12.8992 38 20 38C27.1008 38 32.8572 32.2437 32.8572 25.1429V14.8571Z",
			fill: "none",
			stroke: "var(--icon-default)",
			strokeWidth: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 2V14.8571",
			fill: "none",
			stroke: "var(--icon-default)",
			strokeWidth: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0867 10.4469C22.0867 9.33228 21.1337 8.42871 19.9582 8.42871C18.7827 8.42871 17.8297 9.33228 17.8297 10.4469V14.4833C17.8297 15.5979 18.7827 16.5015 19.9582 16.5015C21.1337 16.5015 22.0867 15.5979 22.0867 14.4833V10.4469Z",
			fill: "var(--icon-primary)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.4286 24.0224L20 29.1653L13.5714 24.0224",
			fill: "none",
			stroke: "var(--icon-primary)",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.4286 20L20 25.1428L13.5714 20",
			fill: "none",
			stroke: "var(--icon-default)",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgScrollZoom;
